import request from '@/Network/Requests/request'
import api from '@/Network/Requests/api'
import Service from '@/Network/Services/Service'
import type {
  WebPushToken,
  WebNotification,
  ListWebNotificationsParams,
  ListWebNotificationsResponse,
  NotificationSummaryResponse
} from '@/types/web-notification.types'

export default class WebNotificationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/web-notifications'
  }

  async subscribe(token: string, deviceInfo?: string): Promise<WebPushToken> {
    const response = (await request.post(this.getCompletePath('/subscribe'), {
      token,
      deviceInfo
    })) as { data: WebPushToken }
    return response.data
  }

  async unsubscribe(token: string): Promise<void> {
    await api.delete(this.getCompletePath('/subscribe'), { data: { token } })
  }

  async list(params?: ListWebNotificationsParams): Promise<ListWebNotificationsResponse> {
    const response = (await request.get(this.getCompletePath(), params)) as {
      data: ListWebNotificationsResponse
    }
    return response.data
  }

  async getSummary(): Promise<NotificationSummaryResponse> {
    const response = (await request.get(this.getCompletePath('/summary'))) as {
      data: NotificationSummaryResponse
    }
    return response.data
  }

  async markAsRead(id: number): Promise<WebNotification> {
    const response = (await request.patch(this.getCompletePath(`/${id}/read`), {})) as {
      data: WebNotification
    }
    return response.data
  }

  async markAllAsRead(): Promise<{ message: string }> {
    const response = (await request.patch(this.getCompletePath('/read-all'), {})) as {
      data: { message: string }
    }
    return response.data
  }
}
